import { Schema } from 'effect';

import { SerializableInternalStateSchema } from '../url/completeUrlState';

export const FilterHistoryState = Schema.Struct({
  filters: Schema.toType(SerializableInternalStateSchema),
  contextId: Schema.String,
  timestamp: Schema.Finite,
});

export const AccessoriesHistoryState = Schema.Struct({
  taxonCode: Schema.NullOr(Schema.String),
  productCode: Schema.String,
  timestamp: Schema.Finite,
});

export const HistoryState = Schema.Struct({
  categoryFilters: Schema.optional(FilterHistoryState),
  accessoriesFilters: Schema.optional(AccessoriesHistoryState),
});

export type FilterHistoryStateType = typeof FilterHistoryState.Type;
export type AccessoriesHistoryStateType = typeof AccessoriesHistoryState.Type;
